import siteData from '../siteData';
import ReactGA from 'react-ga4';

export function handleHashNav(section, callback) {
  return (e) => {
    e.preventDefault();

    const targetElement = document.getElementById(section);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }

    if (callback) {
      callback();
    }
  };
}

export function initStyles() {
  document.documentElement.style.setProperty(`--a1`, siteData.styles.a1);
  document.documentElement.style.setProperty(`--a2`, siteData.styles.a2);

  document.documentElement.style.setProperty(`--b1`, siteData.styles.b1);
  document.documentElement.style.setProperty(`--b2`, siteData.styles.b2);
}

export function initAnalytics() {
  if (siteData.analytics.on) {
    ReactGA.initialize(siteData.analytics.id);
    ReactGA.send({ hitType: 'pageview', page: window.location.origin });
  }
}